// This has to be in a separate file to avoid circular dependencies

export const ROUTES = {
    LOGIN: '/login',
    REMOTE_LOGIN: '/remote-login',
    REMOTE_LOGIN_CALLBACK: '/remote-login-callback',
    HOME: '/',
    FLIGHT_LIST: '/flight-list',
    AIRPORT_LIST: '/airport-list',
    AIRPORT_SUMMARY: '/airport-summary',
    REPORTS: '/reports',
    SYSTEM_HUB: '/system-hub',
    CUSTOMER_ADMIN: '/customer-admin',
    SETTINGS: '/settings',
    MULTI_WINDOW: '/multi-window',
    DASHBOARD: '/dashboard'
} as const;

export type RoutePath = (typeof ROUTES)[keyof typeof ROUTES];
